var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.599778 8.06184L7.00796 14.4699C7.15617 14.6182 7.35403 14.7 7.56499 14.7C7.77595 14.7 7.97381 14.6182 8.12202 14.4699L8.59394 13.9981C8.90102 13.6907 8.90102 13.191 8.59394 12.884L3.21283 7.50294L8.59991 2.11586C8.74812 1.96753 8.82996 1.76979 8.82996 1.55895C8.82996 1.34786 8.74812 1.15013 8.59991 1.00168L8.12799 0.529998C7.97966 0.381667 7.78193 0.299952 7.57096 0.299952C7.36 0.299952 7.16215 0.381667 7.01393 0.529998L0.599778 6.94392C0.451214 7.09272 0.369615 7.29139 0.370083 7.50259C0.369615 7.7146 0.451214 7.91316 0.599778 8.06184Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.7ed3b3b18db5158c3c396b4899472b63.svg";
export { ForwardRef as ReactComponent };